import { render, staticRenderFns } from "./VillaManagement.vue?vue&type=template&id=2d3becb6&scoped=true"
import script from "./VillaManagement.vue?vue&type=script&lang=js"
export * from "./VillaManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3becb6",
  null
  
)

export default component.exports